import React, { createContext, RefObject, useContext } from "react";

const OverlayPortalContainerContext = createContext<
  RefObject<HTMLElement> | undefined
>(undefined);

export function OverlayPortalContainerProvider({
  containerRef,
  children,
}: {
  containerRef: RefObject<HTMLElement>;
  children: React.ReactNode;
}) {
  return (
    <OverlayPortalContainerContext.Provider value={containerRef}>
      {children}
    </OverlayPortalContainerContext.Provider>
  );
}

export function useOverlayPortalContainer() {
  return useContext(OverlayPortalContainerContext);
}
